// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentBrief-module__root___VSGIA {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.AppointmentBrief-module__header___jL9SW {
  padding: 20px;
}

.AppointmentBrief-module__name___P2A0P {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #18181b;
}

.AppointmentBrief-module__demographics___nfTDv {
  font-size: 17px;
  font-weight: 400;
  color: #71717a;
}

.AppointmentBrief-module__whenDetail___LqBzX {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.5;
  color: #3f3f46;
}

.AppointmentBrief-module__notSplit___mFcf8 {
  font-size: 14px;
  line-height: 1.4286;
  color: #71717a;
}

.AppointmentBrief-module__visitLine___GTqA5 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 8px 0 0;
  font-size: 14px;
  color: #3f3f46;
}

.AppointmentBrief-module__dot___bYXtj {
  width: 9px;
  height: 9px;
  flex-shrink: 0;
  border-radius: 999px;
}

.AppointmentBrief-module__visitType___I2ola {
  font-weight: 600;
  color: #18181b;
}

.AppointmentBrief-module__separator___Mcqi5 {
  color: #a1a1aa;
}

.AppointmentBrief-module__lastMoca___e0LiM {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
  margin: 8px 0 0;
  font-size: 14px;
  color: #71717a;
}

.AppointmentBrief-module__actionError___IObjl {
  margin: 8px 0 0;
  font-size: 13px;
  color: #991b1b;
}

.AppointmentBrief-module__root___VSGIA {
  container-type: inline-size;
}

.AppointmentBrief-module__strip____PZL9 {
  margin: 0 20px;
}

@container (max-width: 447px) {
  .AppointmentBrief-module__strip____PZL9 {
    margin: 0 16px;
  }
}
@container (max-width: 639px) {
  .AppointmentBrief-module__header___jL9SW {
    padding: 14px;
  }
  .AppointmentBrief-module__name___P2A0P {
    font-size: 18px;
  }
}
.AppointmentBrief-module__mocaPrompt___TK92P {
  padding: 20px 20px 0;
}

.AppointmentBrief-module__rows___JTVIX {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px;
  border-top: 1px solid #e4e4e7;
}

.AppointmentBrief-module__finding___RUZIA {
  font-weight: 500;
  color: #18181b;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/AppointmentBrief.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AACA;EACE,2BAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE;IACE,cAAA;EAEF;AACF;AACA;EACE;IACE,aAAA;EACF;EAEA;IACE,eAAA;EAAF;AACF;AAGA;EACE,oBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;AADF;;AAIA;EACE,gBAAA;EACA,cAAA;AADF","sourcesContent":[".root {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.header {\n  padding: 20px;\n}\n\n.name {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.demographics {\n  font-size: 17px;\n  font-weight: 400;\n  color: #71717a;\n}\n\n.whenDetail {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #3f3f46;\n}\n\n.notSplit {\n  font-size: 14px;\n  line-height: 1.4286;\n  color: #71717a;\n}\n\n.visitLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #3f3f46;\n}\n\n.dot {\n  width: 9px;\n  height: 9px;\n  flex-shrink: 0;\n  border-radius: 999px;\n}\n\n.visitType {\n  font-weight: 600;\n  color: #18181b;\n}\n\n.separator {\n  color: #a1a1aa;\n}\n\n.lastMoca {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 10px;\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #71717a;\n}\n\n.actionError {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: #991b1b;\n}\n.root {\n  container-type: inline-size;\n}\n\n.strip {\n  margin: 0 20px;\n}\n\n@container (max-width: 447px) {\n  .strip {\n    margin: 0 16px;\n  }\n}\n\n@container (max-width: 639px) {\n  .header {\n    padding: 14px;\n  }\n\n  .name {\n    font-size: 18px;\n  }\n}\n\n.mocaPrompt {\n  padding: 20px 20px 0;\n}\n\n.rows {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 20px;\n  border-top: 1px solid #e4e4e7;\n}\n\n.finding {\n  font-weight: 500;\n  color: #18181b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AppointmentBrief-module__root___VSGIA`,
	"header": `AppointmentBrief-module__header___jL9SW`,
	"name": `AppointmentBrief-module__name___P2A0P`,
	"demographics": `AppointmentBrief-module__demographics___nfTDv`,
	"whenDetail": `AppointmentBrief-module__whenDetail___LqBzX`,
	"notSplit": `AppointmentBrief-module__notSplit___mFcf8`,
	"visitLine": `AppointmentBrief-module__visitLine___GTqA5`,
	"dot": `AppointmentBrief-module__dot___bYXtj`,
	"visitType": `AppointmentBrief-module__visitType___I2ola`,
	"separator": `AppointmentBrief-module__separator___Mcqi5`,
	"lastMoca": `AppointmentBrief-module__lastMoca___e0LiM`,
	"actionError": `AppointmentBrief-module__actionError___IObjl`,
	"strip": `AppointmentBrief-module__strip____PZL9`,
	"mocaPrompt": `AppointmentBrief-module__mocaPrompt___TK92P`,
	"rows": `AppointmentBrief-module__rows___JTVIX`,
	"finding": `AppointmentBrief-module__finding___RUZIA`
};
module.exports = ___CSS_LOADER_EXPORT___;
